import clsx from "clsx";

import type { HttpMethod } from "sandbox/types";

import { METHOD_COLORS } from "sandbox/constants";

import s from "./MethodBadge.module.css";

interface MethodBadgeProps {
  className?: string;
  method: HttpMethod;
  size?: "small" | "medium";
}

export const MethodBadge = ({
  method,
  size = "small",
  className,
}: MethodBadgeProps) => {
  const colors = METHOD_COLORS[method];
  return (
    <span
      className={clsx(s.badge, size === "medium" && s.medium, className)}
      style={{
        color: colors.fg,
        backgroundColor: colors.bg,
        borderColor: colors.border,
      }}
    >
      {method}
    </span>
  );
};
